// Closing-gate Bypass banner.
//
// Prominent, distinct warning surfaced wherever a bypassed escrow row is read
// (Underwriting Section 2 above both escrow views + Closing Step 3), so no one
// mistakes a QA-forced gate for a real, funded escrow close.

import { AlertTriangle } from "lucide-react";
import { useDateFormatter } from "@/utils/datetime";

interface BypassBannerProps {
  bypassedAt: string;
  reason: string | null;
}

export function BypassBanner({ bypassedAt, reason }: BypassBannerProps) {
  const { date } = useDateFormatter();
  return (
    <div
      role="alert"
      data-testid="escrow-bypass-banner"
      className="flex items-start gap-space-2 bg-status-warning/15 border border-status-warning/40 rounded-md px-space-3 py-space-3"
    >
      <AlertTriangle
        size={18}
        className="text-status-warning mt-[1px] shrink-0"
        aria-hidden
      />
      <div className="min-w-0">
        <p className="text-small font-display font-bold uppercase tracking-label text-status-warning m-0">
          ⚠ Bypassed for testing — no verified funds
        </p>
        <p className="text-caption text-onyx m-0 mt-space-1">
          An admin force-completed the Escrow Setup gate for this test deal on{" "}
          {date(bypassedAt)}. No real escrow close has occurred.
          {reason ? <> Reason: {reason}</> : null}
        </p>
      </div>
    </div>
  );
}
